<template>
  <v-container grid-list-xs>
    <v-layout row wrap>
      <v-card elevation="0" class="pt-0">
        <v-card-text fill-height class="pt-0">
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap align-start>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">1</v-chip>
                  </v-flex>
                  <v-flex pa-0 pl-1 mt-2 mb-2>
                    <span class="font-weight-bold primary--text">Remaining Balance</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="Remaining Balance"
                  type="tel"
                  v-model="fields.remaining_balance"
                  append-icon="fa-dollar"
                  @input="handleChange('balance')"
                  maxlength="9"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">2</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Frequency</span>
                  </v-flex>
                </v-layout>
                <v-select
                  label="Frequency"
                  v-model="fields.frequency"
                  :items="recurringTypes"
                  :rules="recurringFrequencyRules"
                  append-icon="fa-refresh"
                  @input="handleChange('frequency')"
                  box
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">3</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text"># Payments</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="# Payments"
                  type="number"
                  v-model="fields.payments"
                  :disabled="!fields.start_date || !fields.frequency"
                  :min="minPayments"
                  append-icon="fa-hashtag"
                  @input="handleChange('payments')"
                  box
                  hide-details
                  :readonly="fields.ongoing"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">4</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Installments</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="Installments"
                  type="tel"
                  v-model="fields.amount"
                  append-icon="fa-dollar"
                  @input="handleChange('amount')"
                  box
                  hide-details
                ></v-text-field>
                <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showRecurringPriceAdjustmentFee=true" v-if="!fields.waive_fee && terminal.is_cashdiscount && schedule.request_type !== 'ach' && !showRecurringPriceAdjustmentFee">
                  <v-flex class="pa-1 pt-2 pl-2 caption white primary--text text-truncate">
                    Show Price Adj Fee
                  </v-flex>
                  <v-flex shrink class="pa-0 white">
                    <v-divider vertical class="primary"></v-divider>
                  </v-flex>
                  <v-flex shrink class="pa-1 pl-2 pr-2 caption white primary--text">
                    &or;
                  </v-flex>
                </v-layout>
                <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showRecurringPriceAdjustmentFee=false" v-if="!fields.waive_fee && terminal.is_cashdiscount && schedule.request_type !== 'ach' && showRecurringPriceAdjustmentFee">
                  <v-flex class="pa-1 pl-2 caption primary white--text">
                    {{ recurringPriceAdjustmentFee }}
                  </v-flex>
                  <v-flex shrink class="pa-0 primary">
                    <v-divider vertical class="white"></v-divider>
                  </v-flex>
                  <v-flex shrink class="pa-1 pl-2 pr-2 caption primary white--text">
                    &and;
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">&#8226;</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Behavior</span>
                  </v-flex>
                </v-layout>
                <v-select
                  label="Installment Behavior"
                  v-model="fields.installment_behavior"
                  :items="installmentBehaviorTypes"
                  append-icon="fa-cog"
                  box
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">5</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Start Date</span>
                  </v-flex>
                </v-layout>
                <v-menu
                  v-model="startDateModal"
                  ref="startDateModal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="fields.start_date"
                  full-width
                  lazy
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
                >
                  <v-text-field
                    label="Start Date"
                    slot="activator"
                    v-model="formattedRecurringStartDate"
                    :rules="recurringStartRules"
                    append-icon="fa-calendar"
                    box
                    hide-details
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="fields.start_date"
                    :min="minimumRecurringStartDate"
                    @input="$refs.startDateModal.save(fields.start_date); handleChange('start_date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 mt-2 mb-2>
                    <span class="font-weight-bold secondary--text">End Date</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="End Date"
                  v-model="formattedRecurringEndDate"
                  append-icon="fa-calendar"
                  box
                  hide-details
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout column wrap>
              <v-flex>
                <div class="font-weight-bold primary--text subheading">IMPORTANT</div>
              </v-flex>
              <v-flex pt-0>
                <div class="caption">All changes to the input boxes above can also be seen below in the Quick-look Summary.</div>
              </v-flex>
            </v-layout>

            <v-divider class="primary"></v-divider>

            <v-layout column wrap>
              <v-flex>
                <span class="primary--text subheading">Quick-look Summary</span>
              </v-flex>
              <v-flex pt-0>
                <table id="modify" width="100%">
                  <tr>
                    <th></th>
                    <th class="primary--text caption">Remainder</th>
                    <th class="primary--text caption">Frequency</th>
                    <th class="primary--text caption">Start Date</th>
                    <th class="primary--text caption">Finish Date</th>
                    <th class="primary--text caption"># Payments</th>
                    <th class="primary--text caption">Installment</th>
                    <th class="primary--text caption">Behavior</th>
                  </tr>
                  <tr>
                    <td class="subheading">Before</td>
                    <td class="text-xs-center">{{ fields.remaining_balance_original }}</td>
                    <td class="text-xs-center">{{ fields.frequency_original }}</td>
                    <td class="text-xs-center">{{ date(fields.start_date_original) }}</td>
                    <td class="text-xs-center">{{ date(fields.end_date_original) }}</td>
                    <td class="text-xs-center">{{ fields.payments_original }}</td>
                    <td class="text-xs-center">{{ fields.amount_original }}</td>
                    <td class="text-xs-center text-capitalize">{{ behaviorLabel(fields.installment_behavior_original) }}</td>
                  </tr>
                  <tr><td colspan="8"><v-divider class="primary"></v-divider></td></tr>
                  <tr>
                    <th></th>
                    <th class="primary--text caption">Total</th>
                    <th class="primary--text caption">Frequency</th>
                    <th class="primary--text caption">Start Date</th>
                    <th class="primary--text caption">Finish Date</th>
                    <th class="primary--text caption"># Payments</th>
                    <th class="primary--text caption">Installment</th>
                    <th class="primary--text caption">Behavior</th>
                  </tr>
                  <tr>
                    <td class="subheading">After</td>
                    <td :class="Number(fields.remaining_balance) !== Number(fields.remaining_balance_original) ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ fields.remaining_balance }}
                    </td>
                    <td :class="fields.frequency !== fields.frequency_original ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ fields.frequency }}
                    </td>
                    <td :class="fields.start_date !== fields.start_date_original ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ date(fields.start_date) }}
                    </td>
                    <td :class="fields.end_date !== fields.end_date_original ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ date(fields.end_date) }}
                    </td>
                    <td :class="Number(fields.payments) !== Number(fields.payments_original) ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ fields.payments }}
                    </td>
                    <td :class="Number(fields.amount) !== Number(fields.amount_original) ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ fields.amount }}
                    </td>
                    <td :class="fields.installment_behavior !== fields.installment_behavior_original ? 'secondary text-xs-center' : 'text-xs-center'">
                      {{ behaviorLabel(fields.installment_behavior) }}
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-flex xs6 class="text-xs-right">
                <template v-if="submitDisabled">
                  By clicking <span class="primary--text">CONFIRM</span> this installment schedule will be modified with <span class="primary--text">new</span> details.
                </template>
              </v-flex>
              <v-flex xs3>
                <v-btn block large @click="closeModal">Cancel</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn block large @click="save" color="primary" :disabled="!submitDisabled">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

export default {
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, DisplayMixin, RecurringMixin, StoreMixin, UtilityMixin],

  data: function () {
    return {
      enabled: false,

      showRecurringPriceAdjustmentFee: false,

      startDateModal: false,

      fields: {
        remaining_balance: null,
        remaining_balance_original: null,

        frequency: 'none',
        frequency_original: 'none',

        payments: 0,
        payments_original: 0,

        amount: null,
        amount_original: null,

        start_date: Moment().add(1, 'days').format('YYYY-MM-DD'),
        start_date_original: Moment().add(1, 'days').format('YYYY-MM-DD'),

        end_date: '',
        end_date_original: '',

        ongoing: false,
        waive_fee: false,

        installment_behavior: 'keep_schedule',
        installment_behavior_original: 'keep_schedule'
      },

      installmentBehaviorTypes: [
        {value: 'keep_schedule', text: 'Keep Schedule'},
        {value: 'end_early', text: 'End Early'}
      ],

      recurringTypes: [
        {value: 'none', text: 'None'},
        {value: 'daily', text: 'Every day'},
        {value: 'weekly', text: 'Every week'},
        {value: 'biweekly', text: 'Every 2 weeks'},
        {value: 'monthly', text: 'Every month'},
        {value: 'annually', text: 'Every year'}
      ],

      recurringFrequencyRules: [
        (v) => (!!v && v !== 'none') || 'Recurring frequency required'
      ],
      recurringStartRules: [
        (v) => (!!v && v !== '') || 'Recurring start date required'
      ]
    }
  },

  props: {
    terminal: Object,
    schedule: Object,
    scheduledTransactions: Array
  },

  mounted () {
    this.load()
  },

  watch: {
    schedule: function () {
      this.load()
    },
    scheduledTransactions: function () {
      this.load()
    }
  },

  computed: {
    formattedRecurringStartDate () {
      return this.fields.start_date ? Moment(this.fields.start_date).format('MMM-DD-YYYY') : ''
    },

    formattedRecurringEndDate () {
      return this.fields.end_date ? Moment(this.fields.end_date).format('MMM-DD-YYYY') : ''
    },

    minimumRecurringStartDate: function () {
      return Moment().format('YYYY-MM-DD')
    },

    recurringPriceAdjustmentFee: function () {
      if (isNaN(this.fields.amount) || this.fields.amount === 0) {
        return ''
      }
      return this.calculateFee(this.terminal, this.fields.amount)
    },

    minPayments: function () {
      return 1
    },

    submitDisabled: function () {
      return Number(this.fields.remaining_balance) !== Number(this.fields.remaining_balance_original) ||
        this.fields.frequency !== this.fields.frequency_original ||
        this.fields.start_date !== this.fields.start_date_original ||
        this.fields.end_date !== this.fields.end_date_original ||
        Number(this.fields.payments) !== Number(this.fields.payments_original) ||
        Number(this.fields.amount) !== Number(this.fields.amount_original) ||
        this.fields.installment_behavior !== this.fields.installment_behavior_original
    }
  },

  methods: {
    async load () {
      if (!this.schedule || !this.schedule.id) return

      this.fields.waive_fee = this.schedule.is_fee_waived

      this.fields.frequency_original = this.fields.frequency = this.schedule.recurring_type

      if (this.schedule.next_run && Moment.utc(this.schedule.next_run).isAfter(Moment())) {
        this.fields.start_date_original = this.fields.start_date = Moment.utc(this.schedule.next_run).format('YYYY-MM-DD')
      } else if (this.schedule.start && Moment.utc(this.schedule.start).isAfter(Moment().add(1, 'days'))) {
        this.fields.start_date_original = this.fields.start_date = Moment.utc(this.schedule.start).format('YYYY-MM-DD')
      } else {
        this.fields.start_date_original = this.fields.start_date = Moment().add(1, 'days').format('YYYY-MM-DD')
      }

      if (this.schedule.end) {
        this.fields.end_date_original = this.fields.end_date = Moment.utc(this.schedule.end).format('YYYY-MM-DD') === '2099-12-31' ? '' : Moment.utc(this.schedule.end).format('YYYY-MM-DD')
        this.fields.ongoing = !!(Moment.utc(this.schedule.end).format('YYYY-MM-DD') === '2099-12-31')
      } else {
        this.fields.end_date_original = this.fields.end_date = ''
        this.fields.ongoing = true
      }

      this.fields.amount_original = this.fields.amount = ((this.schedule.total_amount - this.schedule.fee_amount) / 100).toFixed(2)

      if (this.schedule.installment_count) {
        this.fields.payments_original = this.fields.payments = this.schedule.installment_count
      } else {
        this.setPaymentCount()
        this.fields.payments_original = this.fields.payments
      }

      this.fields.remaining_balance_original = this.fields.remaining_balance = ((this.schedule.installment_remaining_amount || 0) / 100).toFixed(2)

      this.fields.installment_behavior_original = this.fields.installment_behavior = this.schedule.installment_behavior || 'keep_schedule'
    },

    async save () {
      try {
        Bus.$emit('openWaitModal')

        let options = {
          recurring_type: this.fields.frequency,
          start: this.fields.start_date,
          end: this.fields.ongoing ? '2099-12-31' : this.fields.end_date,
          total_amount: (Number(this.fields.amount) + Number(this.recurringPriceAdjustmentFee || 0)).toFixed(2),
          fee_amount: this.recurringPriceAdjustmentFee || 0,
          notify: this.schedule.notify,
          installment_count: Number(this.fields.payments),
          installment_behavior: this.fields.installment_behavior,
          installment_remaining_amount: Math.round(Number(this.fields.remaining_balance) * 100)
        }

        let result = await this.api({
          method: 'put',
          url: `/schedules/${this.schedule.id}`,
          data: options
        })

        if (result.data && !result.data.error) {
          Bus.$emit('openModal', {status: 'success', message: 'Installment schedule has been modified'})
          Bus.$emit('reloadPnxInstallment')
          this.closeModal()
        } else {
          throw new Error('Error while modifying schedule')
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    behaviorLabel (value) {
      let item = this.installmentBehaviorTypes.find(t => t.value === value)
      return item ? item.text : value
    },

    closeModal () {
      Bus.$emit('closeModifyModal')
    },

    handleChange (field) {
      if (field === 'balance' || field === 'frequency') {
        let paymentCount = this.calculatePaymentCountWithRecurringAmount()
        this.$set(this.fields, 'payments', Math.ceil(paymentCount))
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))
      } else if (field === 'payments') {
        if (Number(this.fields.payments) < 1) {
          this.$set(this.fields, 'payments', 1)
        }
        let subtotal = Number(this.fields.remaining_balance) / Number(this.fields.payments)
        if (isNaN(subtotal) || subtotal <= 0 || subtotal === Infinity) {
          return ''
        } else {
          this.$set(this.fields, 'amount', Number(subtotal).toFixed(2))
        }
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))
      } else if (field === 'amount') {
        if (this.fields.ongoing) {
          this.fields.end_date = ''
          this.fields.payments = 0
        } else {
          let paymentCount = this.calculatePaymentCountWithRecurringAmount()
          this.$set(this.fields, 'payments', Math.ceil(paymentCount))
          this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))
        }
      } else if (field === 'start_date') {
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))
      }
    },

    calculatePaymentCountWithRecurringAmount () {
      if (this.fields.frequency === '' || this.fields.frequency === 'none') return 0
      if (this.fields.start_date === '') return 0
      if (this.fields.remaining_balance === '') return 0
      if (this.fields.amount === '') return 0
      return this.fields.remaining_balance / this.fields.amount
    },

    setPaymentCount () {
      if (this.fields.ongoing) {
        this.$set(this.fields, 'end_date', '')
        this.$set(this.fields, 'payments', 0)
      } else if (this.fields.frequency === 'none' || !this.fields.start_date || !this.fields.end_date) {
        this.$set(this.fields, 'payments', 0)
      } else {
        this.$set(this.fields, 'payments', Math.trunc(this.calculatePaymentCountWithEndDate(this.fields.frequency, this.fields.start_date, this.fields.end_date)))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pnxInstallments/ModifyInstallments.vue